/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Shift from './shift';
import ShiftDetail from './shift-detail';
import ShiftUpdate from './shift-update';
import ShiftDeleteDialog from './shift-delete-dialog';

const ShiftRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Shift />} />
    <Route path="new" element={<ShiftUpdate />} />
    <Route path=":id">
      <Route index element={<ShiftDetail />} />
      <Route path="edit" element={<ShiftUpdate />} />
      <Route path="delete" element={<ShiftDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ShiftRoutes;
